import React, { useEffect } from "react";
import PropTypes from "prop-types";
import stickerReward from "assets/mp3/stickerReward.mp3";
import "./index.scss";

const propTypes = {
  sticker: PropTypes.number,
  onClose: PropTypes.func,
};

const defaultProps = {
  sticker: 1,
  onClose: () => {},
};

const StickerModal = ({ sticker, onClose }) => {
  useEffect(() => {
    if (!sticker) {
      if (typeof onClose === "function") {
        onClose();
      }
    }
    var audio = new Audio(stickerReward);
    audio.play();

    setTimeout(() => {
      if (typeof onClose === "function") {
        onClose();
      }
    }, 3000);
  }, [onClose, sticker]);

  return (
    <div className="sticker-modal">
      <div className="sticker-modal__image">
        <img
          alt="sticker"
          src={require(`assets/images/stickers/${sticker}.png`)}
          draggable={false}
        />
      </div>

      <div className="sticker-modal__stars">
        {[...Array(7).keys()].map((v) => (
          <img
            alt="img"
            key={v}
            src={require("assets/images/star.png")}
            draggable={false}
          />
        ))}
      </div>
      <img className='sticker-modal__snow' alt="img" src={require("assets/images/snow.png")} />
    </div>
  );
};

StickerModal.propTypes = propTypes;
StickerModal.defaultProps = defaultProps;

// Avoid re-render
const areEqual = () => true;

export default React.memo(StickerModal, areEqual);
